export default __webpack_public_path__ + "static/mini-verso-3-1dfe339f3446f0a5201f495d79b37a9b.jpg";